import { render } from "./NotificationDetails.vue?vue&type=template&id=2dd2e900&scoped=true"
import script from "./NotificationDetails.vue?vue&type=script&lang=js"
export * from "./NotificationDetails.vue?vue&type=script&lang=js"

import "./NotificationDetails.vue?vue&type=style&index=0&id=2dd2e900&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd2e900"]])

export default __exports__